import { usePageProps, withLayouts } from 'react-dx'
import { NotFoundError } from '@duiyun/strapi-v4'

import DefaultLayout from '../_layout'
import RootLayout from '../_layout/layouts/RootLayout'
import AntdLayout from '../_layout/layouts/AntdLayout'
import SiteSpecificContextLayout from '../_layout/layouts/SiteSpecificContextLayout'

import { getTadReviewData } from './_services'
import { ReviewPage } from './_components/reviews'

import type { InferGetServerSidePropsType, NextPage } from 'next'

import { getServerSideData } from '@/helpers/server-data'

const Page: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = (
  props,
) => {
  const { data } = props

  return <ReviewPage pageData={data?.pageData} />
}
const PageLayout = withLayouts(Page, [
  (props) => {
    return (
      <DefaultLayout
        {...props}
        main={{
          className: 'bg-black',
          includingHeader: true,
        }}
        header={{ transparentOnScrollTop0: true }}
      />
    )
  },
  (props) => {
    const {
      data: { pageData },
    } = usePageProps<InferGetServerSidePropsType<typeof getServerSideProps>>()

    return (
      <RootLayout
        {...props}
        seo={{
          title: pageData.title,
          description: pageData.description,
        }}
      />
    )
  },
  (props) => {
    return <SiteSpecificContextLayout {...props} />
  },
  AntdLayout,
])
export default PageLayout

// eslint-disable-next-line react-refresh/only-export-components
export const getServerSideProps = getServerSideData({ cacheControl: true })(
  async (hostInfo, ctx) => {
    const locale = ctx?.locale || 'en'
    const url = hostInfo.normalizeUrl().url.pathname

    const data = await getTadReviewData(url, locale)
    if (!data) {
      throw new NotFoundError(`url is not found`)
    }

    return {
      type: 'review' as const,
      data,
      url,
    }
  },
)
